import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";
import { PetGameObject } from "$/game/prefabs/PetGameObject.ts";
import { BallPhysicsObject } from "$/game/prefabs/home/BallInteractiveObject.ts";
import { petActions } from "$/game/emitters.ts";

interface MatterCollisionEvent {
  pairs: Array<{
    bodyA: MatterJS.BodyType;
    bodyB: MatterJS.BodyType;
  }>;
}

export class PlayBallSystem {
  private lastHitTime: number = 0;
  private collisionListener?: (event: MatterCollisionEvent) => void;

  constructor(
    private myScene: BasicScene,
    private pet: PetGameObject,
    private ball: BallPhysicsObject,
  ) {
    this.setupCollisionDetection();
  }

  private setupCollisionDetection(): void {
    // Подписываемся на события коллизий Matter.js
    this.collisionListener = (event: MatterCollisionEvent) => {
      this.checkCollision(event);
    };
    this.myScene.matter.world.on("collisionstart", this.collisionListener);
  }

  private checkCollision(event: MatterCollisionEvent): void {
    // Получаем пары коллизий из события
    const pairs = event.pairs || [];

    for (const pair of pairs) {
      const bodyA = pair.bodyA;
      const bodyB = pair.bodyB;

      // Проверяем, что одна из тел - это мяч, а другая - питомец
      const isBallInCollision = bodyA === this.ball.body ||
        bodyB === this.ball.body;
      const isPetInCollision = bodyA === this.pet.body ||
        bodyB === this.pet.body;

      if (isBallInCollision && isPetInCollision) {
        this.handleBallHit();
        break; // Обработали коллизию, выходим
      }
    }
  }

  private handleBallHit(): void {
    // Проверяем, что мяч не захвачен мышкой
    if (this.ball.grabbed) {
      return;
    }

    // Проверяем, что мяч не статичен (не перетаскивается)
    const ballBody = this.ball.body as MatterJS.BodyType | null;
    if (!ballBody || ballBody.isStatic) {
      return;
    }

    // Проверяем, что мяч не перетаскивается сам по себе (имеет скорость)
    const ballBodyVelocity = ballBody.velocity;
    if (!ballBodyVelocity) {
      return;
    }
    const speed = Math.sqrt(
      ballBodyVelocity.x * ballBodyVelocity.x +
        ballBodyVelocity.y * ballBodyVelocity.y,
    );
    if (speed < 0.1) {
      return; // Мяч практически не движется, не засчитываем удар
    }

    // Проверяем, прошло ли достаточно времени с последнего удара
    const config = this.myScene.global.TUNER_TWA_CONFIG.game.systems.ball;
    const currentTime = this.myScene.time.now;
    const timeSinceLastHit = currentTime - this.lastHitTime;

    if (timeSinceLastHit >= config.hitCooldown) {
      // Засчитываем удар
      this.lastHitTime = currentTime;
      petActions.ballPlayed();
      this.myScene.api.pet.playBall();
    }
  }

  public destroy(): void {
    // Отписываемся от событий коллизий
    if (this.collisionListener) {
      this.myScene.matter.world.off("collisionstart", this.collisionListener);
    }
  }
}
